export function managePnjPath({
  pnj,
  pnjPosX,
  pnjPosY,
  scaledX,
  scaledY,
}) {
  let pathDirection = pnj.pathDirection ?? "forward";

  // Always use a copied version to avoid mutating pnj.waypoints
  let waypoints = pathDirection === "forward"
    ? [...pnj.waypoints]
    : [...pnj.waypoints].reverse();

  let currentIndex = pnj.currentWaypointIndex ?? 0;
  let targetWaypoint = waypoints[currentIndex + 1];

  if (!targetWaypoint) {
    // End of path
    pathDirection = pathDirection === "forward" ? "backward" : "forward";
    waypoints = [...waypoints].reverse();
    currentIndex = 0;
    targetWaypoint = waypoints[1];
  }

  const targetX = scaledX(targetWaypoint.x);
  const targetY = scaledY(targetWaypoint.y);
  const deltaX = targetX - pnjPosX;
  const deltaY = targetY - pnjPosY;
  const distance = Math.sqrt(deltaX ** 2 + deltaY ** 2);

  // If close to target, update index (we do it in movePnjs)
  const reached = distance < pnj.speed;
  const newIndex = reached ? currentIndex + 1 : currentIndex;

  return {
    normX: (deltaX / distance) * pnj.speed,
    normY: (deltaY / distance) * pnj.speed,
    newDX: Math.sign(deltaX),
    newIndex,
    pathDirection,
  };
}



export function managePnjTrippedItems({
  items,
  scaledX,
  scaledY,
  scaledHeight,
  scaledWidth,
  // pnjScaledX,
  newX,
  newY,
}) {
  return items.find((item) => {
    return (
      scaledY(newY) >= scaledY(item.position.y) &&
      scaledY(newY) <= scaledY(item.position.y) + scaledHeight(item.size.height) &&
      scaledX(newX) >= scaledX(item.position.x) &&
      scaledX(newX) <= scaledX(item.position.x) + scaledWidth(item.size.width) &&
      item?.isBroken
    );
  });
}

export function managePnjBoxes({
  pnj,
  pnjPosX,
  pnjPosY,
  scaledX,
  scaledY,
  scaledWidth,
  scaledHeight,
  pickupZones,
  dropZones,
}) {
  const hasBoxes = pnj.boxes ?? 0;

  // Find the pickup zone the PNJ is in
  const validPickupZone = pickupZones.find((zone) => {
    const zoneX = scaledX(zone.position.x);
    const zoneY = scaledY(zone.position.y);
    const zoneW = scaledWidth(10);
    const zoneH = scaledHeight(zone.size.height);

    const inZone =
      pnjPosX >= zoneX &&
      pnjPosX <= zoneX + zoneW &&
      pnjPosY >= zoneY &&
      pnjPosY <= zoneY + zoneH

    return inZone && zone.boxes > 0;
  });

  // Find the first drop zone the PNJ is in and that has capacity
  const validDropZone = dropZones.find((zone) => {
    const zoneX = scaledX(zone.position.x);
    const zoneY = scaledY(zone.position.y);
    const zoneW = scaledWidth(zone.size.width);
    const zoneH = scaledHeight(zone.size.height);

    const inZone =
      pnjPosX >= zoneX &&
      pnjPosX <= zoneX + zoneW &&
      pnjPosY >= zoneY &&
      pnjPosY <= zoneY + zoneH;

    return inZone && zone.boxes < zone.maxBoxes;
  });

  return {
    hasBoxes,
    inPickupZone: !!validPickupZone,
    inValidDropZone: !!validDropZone,
    validPickupZone,
    validDropZone,
  };
}

